'use strict';
/**
 * Dependencies
 */

var _classCallCheck = require("/Users/naderzouaoui/Documents/devProjects/technolab-web-app/Product/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/naderzouaoui/Documents/devProjects/technolab-web-app/Product/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('@sendgrid/client'),
    Client = _require.Client;

var _require2 = require('@sendgrid/helpers'),
    Mail = _require2.classes.Mail;
/**
 * Mail service class
 */


var MailService =
/*#__PURE__*/
function () {
  /**
   * Constructor
   */
  function MailService() {
    _classCallCheck(this, MailService);

    //Set client, initialize substitution wrappers and secret rules
    //filter
    this.setClient(new Client());
    this.setSubstitutionWrappers('{{', '}}');
    this.secretRules = [];
  }
  /**
   * Set client
   */


  _createClass(MailService, [{
    key: "setClient",
    value: function setClient(client) {
      this.client = client;
    }
    /**
     * API key pass through for convenience
     */

  }, {
    key: "setApiKey",
    value: function setApiKey(apiKey) {
      this.client.setApiKey(apiKey);
    }
    /**
     * Set substitution wrappers
     */

  }, {
    key: "setSubstitutionWrappers",
    value: function setSubstitutionWrappers(left, right) {
      if (typeof left === 'undefined' || typeof right === 'undefined') {
        throw new Error('Must provide both left and right side wrappers');
      }

      if (!Array.isArray(this.substitutionWrappers)) {
        this.substitutionWrappers = [];
      }

      this.substitutionWrappers[0] = left;
      this.substitutionWrappers[1] = right;
    }
    /**
     * Set secret rules for filtering the e-mail content
     */

  }, {
    key: "setSecretRules",
    value: function setSecretRules(rules) {
      if (!(rules instanceof Array)) {
        rules = [rules];
      }

      var tmpRules = rules.map(function (rule) {
        var ruleType = typeof rule;

        if (ruleType === 'string') {
          return {
            pattern: new RegExp(rule)
          };
        } else if (ruleType === 'object') {
          // normalize rule object
          if (rule instanceof RegExp) {
            rule = {
              pattern: rule
            };
          } else if (rule.hasOwnProperty('pattern') && typeof rule.pattern === 'string') {
            rule.pattern = new RegExp(rule.pattern);
          }

          try {
            // test if rule.pattern is a valid regex
            rule.pattern.test('');
            return rule;
          } catch (err) {// continue regardless of error
          }
        }
      });
      this.secretRules = tmpRules.filter(function (val) {
        return val;
      });
    }
    /**
     * Check if the e-mail is safe to be sent
     */

  }, {
    key: "filterSecrets",
    value: function filterSecrets(body) {
      if (typeof body === 'object' && !body.hasOwnProperty('content')) {
        return;
      }

      var self = this;
      body.content.forEach(function (data) {
        self.secretRules.forEach(function (rule) {
          if (rule.hasOwnProperty('pattern') && !rule.pattern.test(data.value)) {
            return;
          }

          var message = "The pattern '".concat(rule.pattern, "'");

          if (rule.name) {
            message += "identified by '".concat(rule.name, "'");
          }

          message += " was found in the Mail content!";
          throw new Error(message);
        });
      });
    }
    /**
     * Send email
     */

  }, {
    key: "send",
    value: function send(data) {
      var _this = this;

      var isMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var cb = arguments.length > 2 ? arguments[2] : undefined;

      //Callback as second parameter
      if (typeof isMultiple === 'function') {
        cb = isMultiple;
        isMultiple = false;
      } //Array? Send in parallel


      if (Array.isArray(data)) {
        //Create promise
        var promise = Promise.all(data.map(function (item) {
          return _this.send(item, isMultiple);
        })); //Execute callback if provided

        if (cb) {
          promise.then(function (result) {
            return cb(null, result);
          }).catch(function (error) {
            return cb(error, null);
          });
        } //Return promise


        return promise;
      } //Send mail


      try {
        //Append multiple flag to data if not set
        if (typeof data.isMultiple === 'undefined') {
          data.isMultiple = isMultiple;
        } //Append global substitution wrappers if not set in data


        if (typeof data.substitutionWrappers === 'undefined') {
          data.substitutionWrappers = this.substitutionWrappers;
        } //Create Mail instance from data and get JSON body for request


        var mail = Mail.create(data);
        var body = mail.toJSON(); //Filters the Mail body to avoid sensitive content leakage

        this.filterSecrets(body); //Create request

        var request = {
          method: 'POST',
          url: '/v3/mail/send',
          body: body
        }; //Send

        return this.client.request(request, cb);
      } //Catch sync errors
      catch (error) {
        //Pass to callback if provided
        if (cb) {
          // eslint-disable-next-line callback-return
          cb(error, null);
        } //Reject promise


        return Promise.reject(error);
      }
    }
    /**
     * Send multiple emails (shortcut)
     */

  }, {
    key: "sendMultiple",
    value: function sendMultiple(data, cb) {
      return this.send(data, true, cb);
    }
  }]);

  return MailService;
}(); //Export class


module.exports = MailService;